module.exports = __webpack_public_path__ + "img/tacostequila.626e33e6.jpeg";